// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_5hl","cls2":"CiterightMiniReport-cls2_64M CiterightMiniReport-cls1_5hl"};